import classNames from 'classnames';
import { Typography, Col } from 'antd';
import './index.less';
import React from 'react';
import FilterTagGroup from './group';

const FilterTag = ({
  multiple = false,
  selected = false,
  value = '',
  children = '',
  border = true,
  currValue = '',
  onChange = () => {},
}) => {
  return (
    <Col>
      <span
        onClick={() => {
          if (multiple) {
            let copy = Object.assign([], currValue);
            copy = selected ? copy.filter((item) => item !== value) : copy.concat([value]);
            onChange(copy);
          } else {
            onChange(value);
          }
        }}
        className={classNames({
          TY_filter_tag_item: true,
          selected: selected,
          border: border,
        })}
      >
        <Typography.Text
          style={{
            maxWidth: 120,
            color: 'inherit',
          }}
          ellipsis={{
            tooltip: `${children}`,
          }}
        >
          {children}
        </Typography.Text>
      </span>
    </Col>
  );
};

FilterTag.Group = FilterTagGroup;

export default FilterTag;
